import React from "react";
import PropTypes from "prop-types";
// Form
import { Field } from "redux-form";
// Validators
import { date, required } from "../../services/validators";
// Components
import Input, { DateInput } from "../Input";
import Select from "../Select";

function ProfileFields({
  languagesOptions,
  isoCountryOptions,
  fieldNames: {
    birthDate,
    city,
    isoCountryAlpha3,
    preferredCommunicationLocaleCode,
    firstName,
    lastName,
    postalCode,
    street,
    street2
  },
  options: {
    enableUserDataEdit
  }
}) {
  return (
    <fieldset>
      { Boolean(enableUserDataEdit) && <>
        <div className="row">
          <section className="col col-6">
            <Field
              component={Input}
              iconClass="icon-append fa fa-user"
              label={firstName}
              name="firstName"
              type="text"
              validate={required}
            />
          </section>
          <section className="col col-6">
            <Field
              component={Input}
              iconClass="icon-append fa fa-user"
              label={lastName}
              name="lastName"
              type="text"
              validate={required}
            />
          </section>
        </div>
        <div className="row">
          <section className="col col-6">
            <Field
              component={DateInput}
              iconClass="icon-append fa fa-calendar"
              label={birthDate}
              name="birthday"
              validate={[date, required]}
            />
          </section>
        </div>
        <div className="row">
          <section className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <Field
              component={Input}
              iconClass="icon-append fa fa-home"
              label={street}
              name="street"
              type="text"
              validate={required}
            />
          </section>
        </div>
        <div className="row">
          <section className="col col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <Field
              component={Input}
              iconClass="icon-append fa fa-home"
              label={street2}
              name="streetNumber"
              type="text"
            />
          </section>
        </div>
        <div className="row">
          <section className="col col-6">
            <Field
              component={Input}
              iconClass="icon-append fa fa-home"
              label={postalCode}
              name="postcode"
              type="text"
              validate={required}
            />
          </section>
          <section className="col col-6">
            <Field
              component={Input}
              iconClass="icon-append fa fa-location-arrow"
              label={city}
              name="city"
              type="text"
              validate={required}
            />
          </section>
        </div>
        <div className="row">
          <section className="col col-6">
            <Field
              component={Select}
              label={isoCountryAlpha3}
              name="isoCountryAlpha3"
              options={isoCountryOptions}
              validate={required}
            />
          </section>
        </div> </>}
      <div className="row">
        <section className="col col-6">
          <Field
            component={Select}
            label={preferredCommunicationLocaleCode}
            name="preferredCommunicationLocaleCode"
            options={languagesOptions}
          />
        </section>
      </div>
    </fieldset>
  );
}

ProfileFields.propTypes = {
  languagesOptions: PropTypes.array.isRequired,
  isoCountryOptions: PropTypes.array.isRequired,
  fieldNames: PropTypes.shape({
    birthDate: PropTypes.string,
    city: PropTypes.string,
    isoCountryAlpha3: PropTypes.string,
    preferredCommunicationLocaleCode: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    postalCode: PropTypes.string,
    street: PropTypes.string,
    street2: PropTypes.string
  }).isRequired,
  options: PropTypes.shape({
    enableUserDataEdit: PropTypes.bool.isRequired
  }).isRequired
};

export default ProfileFields;
